import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';
import Menu from './Menu.js';
import LocalizationMenu from './LocalizationMenu.js';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    components: {
      Menu,
      LocalizationMenu,
    },
  };

  /**
   * Mounted hook
   */
  mounted() {
    this.updateMenuHeight();
  }

  /**
   * Resized hook
   */
  resized() {
    this.updateMenuHeight();
  }

  /**
   * Update the available height for the mobile menu,
   * accounting for the announcement bar when visible.
   */
  updateMenuHeight() {
    const bottom = this.$el.getBoundingClientRect().bottom;
    const availableHeight = window.innerHeight - bottom;
    this.$el.style.setProperty('--menu-available-height', `${availableHeight}px`);
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    const isOnTop = y <= 0;
    const isNearTop = y < 128;

    toggleClass(document.documentElement, 'is-on-top', isOnTop);
    toggleClass(document.documentElement, 'is-near-top', isNearTop);

    if (direction.y === 'NONE') {
      return;
    }

    toggleClass(document.documentElement, 'is-scrolling-down', direction.y === 'DOWN');
    toggleClass(document.documentElement, 'is-scrolling-up', direction.y === 'UP');

    this.updateMenuHeight();
  }

  /**
   *
   */
  onMenuOpen() {
    const openedMenus = this.$children.Menu.filter(({ isOpen }) => isOpen);
    toggleClass(document.documentElement, 'is-menu-open', openedMenus.length > 0);
  }

  /**
   *
   */
  onMenuClose() {
    const openedMenus = this.$children.Menu.filter(({ isOpen }) => isOpen);
    toggleClass(document.documentElement, 'is-menu-open', openedMenus.length > 0);
  }
}
